import { type FormEvent, useEffect, useState } from 'react';
import { getEmailOptOut, mutateJson, setEmailOptOut } from '../api/client';
import { Field, Input } from '../components/form';
import { Alert, Button, Card } from '../components/ui';
import { navigate } from '../router';

/** Preferência de notificações por e-mail (opt-out, LGPD/#72). */
function PreferenciasEmail() {
  const [optOut, setOptOut] = useState(false);
  const [carregando, setCarregando] = useState(true);
  const [salvo, setSalvo] = useState(false);

  useEffect(() => {
    void getEmailOptOut().then((v) => {
      setOptOut(v);
      setCarregando(false);
    });
  }, []);

  async function onToggle(novo: boolean) {
    setOptOut(novo);
    setSalvo(false);
    const res = await setEmailOptOut(novo);
    if (res.ok) setSalvo(true);
    else setOptOut(!novo);
  }

  return (
    <Card title="Notificações por e-mail" className="stack">
      <p className="muted">
        Receba avisos de fatura publicada e lembretes de pendência. E-mails de segurança (como
        recuperação de senha) são sempre enviados.
      </p>
      <label style={{ display: 'flex', gap: 'var(--space-2)', alignItems: 'center' }}>
        <input
          type="checkbox"
          checked={!optOut}
          disabled={carregando}
          onChange={(e) => onToggle(!e.target.checked)}
        />
        Quero receber notificações por e-mail
      </label>
      {salvo ? <Alert kind="success">Preferência salva.</Alert> : null}
    </Card>
  );
}

export function TrocaSenha() {
  const [senhaAtual, setSenhaAtual] = useState('');
  const [senhaNova, setSenhaNova] = useState('');
  const [erro, setErro] = useState<string | null>(null);
  const [ok, setOk] = useState(false);

  async function onSubmit(e: FormEvent) {
    e.preventDefault();
    setErro(null);
    setOk(false);
    if (senhaNova.length < 8) {
      setErro('A nova senha precisa de pelo menos 8 caracteres.');
      return;
    }
    const res = await mutateJson('/api/me/senha', { senhaAtual, senhaNova });
    if (res.ok) {
      setSenhaAtual('');
      setSenhaNova('');
      setOk(true);
      setTimeout(() => navigate('/'), 900);
    } else if (res.status === 401) {
      setErro('Senha atual incorreta.');
    } else {
      setErro('Não foi possível trocar a senha.');
    }
  }

  return (
    <div className="stack">
      <form onSubmit={onSubmit} noValidate>
        <Field label="Senha atual">
          {(id) => (
            <Input
              id={id}
              type="password"
              autoComplete="current-password"
              value={senhaAtual}
              onChange={(e) => setSenhaAtual(e.target.value)}
            />
          )}
        </Field>
        <Field label="Nova senha (mín. 8 caracteres)">
          {(id) => (
            <Input
              id={id}
              type="password"
              autoComplete="new-password"
              value={senhaNova}
              onChange={(e) => setSenhaNova(e.target.value)}
            />
          )}
        </Field>
        {erro ? <Alert kind="danger">{erro}</Alert> : null}
        {ok ? <Alert kind="success">Senha atualizada.</Alert> : null}
        <div style={{ marginTop: 'var(--space-4)' }}>
          <Button type="submit">Atualizar senha</Button>
        </div>
      </form>
      <PreferenciasEmail />
    </div>
  );
}
